"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useYupLocalization = void 0;
var yup_1 = require("yup");
var react_1 = require("react");
var design_system_foundations_1 = require("@contrast-security-inc/design-system-foundations");
var messages = __importStar(require("./translations"));
var useYupLocalization = function () {
    var formatMessage = (0, design_system_foundations_1.useLocalizationContext)().formatMessage;
    // This should not be needed, but importing jsons and doing a typeof messages breaks with
    // Types of property 'en' are incompatible.
    // Type 'string' is not assignable to type 'Record<string, string>'.
    var correctlyTypedMessages = messages;
    // Validation message properties are here: https://github.com/jquense/yup/blob/master/src/locale.ts
    var translations = (0, react_1.useMemo)(function () { return ({
        mixed: {
            default: formatMessage(correctlyTypedMessages, 'validation.mixed.default'),
            required: formatMessage(correctlyTypedMessages, 'validation.mixed.required'),
            defined: formatMessage(correctlyTypedMessages, 'validation.mixed.defined'),
            oneOf: function (_a) {
                var values = _a.values;
                return formatMessage(correctlyTypedMessages, 'validation.mixed.oneOf', { values: values });
            },
            notOneOf: function (_a) {
                var values = _a.values;
                return formatMessage(correctlyTypedMessages, 'validation.mixed.notOneOf', { values: values });
            },
            notType: function (_a) {
                var type = _a.type;
                return formatMessage(correctlyTypedMessages, 'validation.mixed.notType', { type: type });
            },
        },
        string: {
            length: function (_a) {
                var length = _a.length;
                return formatMessage(correctlyTypedMessages, 'validation.string.length', { length: length });
            },
            min: function (_a) {
                var min = _a.min;
                return formatMessage(correctlyTypedMessages, 'validation.string.min', { min: min });
            },
            max: function (_a) {
                var max = _a.max;
                return formatMessage(correctlyTypedMessages, 'validation.string.max', { max: max });
            },
            matches: function (_a) {
                var regex = _a.regex;
                return formatMessage(correctlyTypedMessages, 'validation.string.matches', {
                    regex: regex.toString(),
                });
            },
            email: function (_a) {
                var regex = _a.regex;
                return formatMessage(correctlyTypedMessages, 'validation.string.email', { regex: regex.toString() });
            },
            url: formatMessage(correctlyTypedMessages, 'validation.string.url'),
            uuid: formatMessage(correctlyTypedMessages, 'validation.string.uuid'),
            trim: formatMessage(correctlyTypedMessages, 'validation.string.trim'),
            lowercase: formatMessage(correctlyTypedMessages, 'validation.string.lowercase'),
            uppercase: formatMessage(correctlyTypedMessages, 'validation.string.uppercase'),
        },
        number: {
            min: function (_a) {
                var min = _a.min;
                return formatMessage(correctlyTypedMessages, 'validation.number.min', { min: min });
            },
            max: function (_a) {
                var max = _a.max;
                return formatMessage(correctlyTypedMessages, 'validation.number.max', { max: max });
            },
            lessThan: function (_a) {
                var less = _a.less;
                return formatMessage(correctlyTypedMessages, 'validation.number.lessThan', { less: less });
            },
            moreThan: function (_a) {
                var more = _a.more;
                return formatMessage(correctlyTypedMessages, 'validation.number.moreThan', { more: more });
            },
            positive: formatMessage(correctlyTypedMessages, 'validation.number.positive'),
            negative: formatMessage(correctlyTypedMessages, 'validation.number.negative'),
            integer: formatMessage(correctlyTypedMessages, 'validation.number.integer'),
        },
        date: {
            min: function (_a) {
                var min = _a.min;
                return formatMessage(correctlyTypedMessages, 'validation.date.min', {
                    min: typeof min === 'string' ? min : min.toLocaleDateString(),
                });
            },
            max: function (_a) {
                var max = _a.max;
                return formatMessage(correctlyTypedMessages, 'validation.date.max', {
                    max: typeof max === 'string' ? max : max.toLocaleDateString(),
                });
            },
        },
        boolean: {
            isValue: function (_a) {
                var value = _a.value;
                return formatMessage(correctlyTypedMessages, 'validation.boolean.isValue', { value: value });
            },
        },
        // need this fixed https://github.com/jquense/yup/issues/1596
        // object: {
        //   noUnknown: () => formatMessage(correctlyTypedMessages, 'validation.object.noUnknown'),
        // },
        array: {
            min: function (_a) {
                var min = _a.min;
                return formatMessage(correctlyTypedMessages, 'validation.array.min', { min: min });
            },
            max: function (_a) {
                var max = _a.max;
                return formatMessage(correctlyTypedMessages, 'validation.array.max', { max: max });
            },
            length: function (_a) {
                var length = _a.length;
                return formatMessage(correctlyTypedMessages, 'validation.array.length', { length: length });
            },
        },
    }); }, [correctlyTypedMessages, formatMessage]);
    try {
        (0, yup_1.setLocale)(translations);
    }
    catch (error) {
        console.error('Setting translated messages with setLocale failed, check your version of yup matches our peer dependency.', error);
    }
};
exports.useYupLocalization = useYupLocalization;
